import { css } from '@emotion/css';

function OneOnOne() {
  const OneOnOneStyles = css``;

  return <div className={OneOnOneStyles}>OneOnOne</div>;
}

export default OneOnOne;
